import { issueExchangeStatusOptions } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/constants'

import { refundTriggerOptions } from './PolicyRuleActionEditor/ActionConfigs/ForceRefundTriggerConfig/constants'
import { actionTypeValues } from './PolicyRuleActionEditor/constants'
import { validateActionConfig } from './PolicyRuleActionEditor/helpers'
import { validateConditions } from './PolicyRuleConditionsEditor/helpers'
import { errorTypes } from './constants'

export const mapCurrencyOptions = currencies => (currencies || []).map(c => ({ label: c.name, value: c.code }))

const hasAllStatuses = (options, availableStatuses) => {
  return options.every(option => {
    return availableStatuses?.includes(option.value)
  })
}

export const getDisabledActions = (disabledActions, availableIssueRefundStatuses, availableIssueExchangeStatuses) => {
  const result = [...disabledActions]

  if (!hasAllStatuses(refundTriggerOptions, availableIssueRefundStatuses)) {
    result.push(actionTypeValues.forceRefundTrigger)
  }
  if (!hasAllStatuses(issueExchangeStatusOptions, availableIssueExchangeStatuses)) {
    result.push(actionTypeValues.forceExchangeOrderTrigger)
  }

  return result
}

export const validatePolicyRule = (policyRule, supportedLanguages = []) => {
  const errors = []

  if (!policyRule.name?.trim()) {
    errors.push({ type: errorTypes.nameEmpty })
  }

  if (!policyRule.action_type) {
    errors.push({ type: errorTypes.actionTypeEmpty })
  }

  const actionErrors = validateActionConfig(
    policyRule.action_type,
    policyRule.action_config || {},
    errorTypes,
    supportedLanguages
  )
  errors.push(...actionErrors)

  const conditionErrors = validateConditions(policyRule.conditions || [])
  errors.push(...conditionErrors)

  return errors
}
